module.exports = __webpack_public_path__ + "static/media/icon-collaboration.ca8c71cf.svg";